import { Tile } from '@diwata/ironvale'
import type { ProjectsFeed } from '@/api/feeds'
import { envelopeStatus, UnavailableNote } from './shared'

/**
 * The board the founder asked for: every grain workspace's phase + task at a
 * glance. Rows deep-link to the workspace's backlog (the owning surface).
 */
export function ProjectsTile({ feed }: { feed: ProjectsFeed }) {
  const items = [...(feed.items ?? [])].sort((a, b) =>
    (b.last_activity ?? '').localeCompare(a.last_activity ?? ''),
  )
  return (
    <Tile title="Projects" status={envelopeStatus(feed)} asOf={feed.asOf} className="ap-tile--wide">
      {feed.status === 'unavailable' ? (
        <UnavailableNote feed={feed} />
      ) : (
        <div className="ap-project-rows">
          {items.map((item) => (
            <a
              key={`${item.repo}:${item.path}`}
              className="ap-project-row"
              href={item.link}
              target="_blank"
              rel="noreferrer"
            >
              <span className="ap-project-name">{item.workspace}</span>
              <span className="ap-project-phase">{item.phase ?? '—'}</span>
              <span className="ap-project-task">
                {item.task_id ? (
                  <>
                    <span className="ap-mono">{item.task_id}</span>
                    {item.task_status && <span className="ap-task-status"> · {item.task_status}</span>}
                  </>
                ) : (
                  <span className="ap-task-status">no active task</span>
                )}
              </span>
              <span className="ap-project-counts ap-mono">
                {item.phases_done}/{item.phases_total}
              </span>
              <span className="ap-project-activity ap-mono">{item.last_activity ?? '—'}</span>
            </a>
          ))}
        </div>
      )}
    </Tile>
  )
}
